/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const EditOutlinedBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M18.553 4.391a.25.25 0 0 0-.354 0L17.131 5.46a.25.25 0 0 0 0 .354l1.057 1.057a.25.25 0 0 0 .354 0l1.067-1.068a.25.25 0 0 0 0-.354l-1.056-1.057Zm-1.439 3.907a.25.25 0 0 0 0-.353l-1.056-1.057a.25.25 0 0 0-.354 0L4.55 18.05l-.318 1.424a.25.25 0 0 0 .297.3l1.432-.314L17.114 8.298Zm.22-5.872c.613-.613 1.555-.528 2.102.02l2.119 2.119c.547.547.631 1.489.02 2.1L7.292 20.956a1.632 1.632 0 0 1-.811.439L3.709 22l-.116-.002c-.49-.007-.872-.271-1.092-.489-.22-.218-.484-.595-.5-1.08v-.014L2 20.284l.617-2.764c.065-.29.205-.573.436-.803L17.335 2.426Z" /></svg>);
const EditOutlined = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={EditOutlinedBase} {...rest} ref={ref} />);
export default EditOutlined;